import React from "react";
import "../Style/Header.css";
import { useAppointment } from "./AppointmentContext.js";
import BookAppointment from "./BookAppointment.js";

function Header() {
  const { appointmentData, handleAppointment } = useAppointment();
  return (
    <header className="hero-section">
      <div className="text-container">
        <h1>
          A DROP OF HOMEOPATHIC MEDICINE CAN CHANGE THE QUALITY OF YOUR LIFE.!
        </h1>
        <p>
          Over a long period, we have provided hundreds of thousands of care
          services to serve the needs of our Patients
        </p>
        <button onClick={handleAppointment}>Make an Appointment</button>
      </div>
      {appointmentData && (
        <div className="popup-overlay" onClick={handleAppointment}>
          <BookAppointment handleAppointment={handleAppointment} />
        </div>
      )}
    </header>
  );
}

export default Header;
